<template>
	<layout-admin>
		<div class="pb-18 divide-y-2 divide-gray-200">
			<ui-alert
				v-if="success"
				type="success"
				message="Your inputs have been saved!"
			/>
			<ui-alert
				v-else-if="hasErrors"
				type="error"
				message="Your input could not be saved!"
			/>

			<div class="p-6">
				<h1 class="text-2xl font-semibold text-gray-900 mb-4">
					{{ __(offer.trade == "BUY" ? "Buy Offer" : "Sell Offer") }} #{{
						offer.id
					}}
					{{ __("by") }} {{ offerUser.company_name }}
				</h1>

				<div class="fixed bottom-0 left-0 px-6 pt-4 pb-9 z-15">
					<ui-button
						class="flex gap-x-2 items-center text-xl font-bold shadow-xl"
						label="Save"
						v-on:click="submitForm()"
						:disabled="submitButtonDisabled"
					>
						<ui-icon
							class="flex-shrink-0 h-6 w-6 -ml-1"
							name="save"
							stroke-width="1.5"
						/>
						{{ __("Save") }}
					</ui-button>
				</div>
			</div>
			<div
				class="contentcontainer med left"
				style="margin-left: 20px; margin-right: 20px"
			>
				<paper-offers-edit-component
					:form="form"
					:offer="offer"
					:active-futures="activeFutures"
				/>
			</div>
			<div>
				<thread-short-list :data="threads" :user="offerUser" :form="form" />
			</div>
		</div>
	</layout-admin>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		offerUser: {
			type: Object,
			required: true,
		},
		userUploads: {
			type: Array,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		success: {
			type: Boolean,
			default: null,
		},
		threads: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			adminUser: this.$inertia.page.props.user,
			form: Vue.observable(
				this.$inertia.form(JSON.parse(JSON.stringify(this.offer)))
			),
			submitButtonDisabled: false,
		};
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "patch",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
	},
	computed: {
		hasErrors() {
			return Object.keys(this.form.errors ?? {}).length > 0;
		},
	},
};
</script>
